// extracted by mini-css-extract-plugin
export default {"base":"style_base__e69wJ","info":"style_info__qKx4J","root":"style_root__0Knoj"};